﻿// Types for Activities Dashboard data structures
export type IngestTrainRow = {
  idTrain: number;
  vcompleted: number;
  vdate: string | null;
  vname: string | null;
  vperiod: number;
  vsent: number;
  vtrainer: string | null;
  vusers: number;
};

export type IngestDevice = {
  idDevice: number;
  vname: string | null;
  vnumber: number;
  vmax: number;
};

export type MemberParticipantSummary = {
  participantId: string;
  userId: number;
  userName: string | null;
  userPseudo: string | null;
  vCal: number;
  vHr: number;
  vHrMax: number;
  device?: IngestDevice | null;
};

export type TrainingLoadResult = {
  totalTSS: number;
  totalTRIMP: number;
  totalTRIMPBanister: number;
  totalPhuketFitStressScore: number;
  sessionDurationHours: number;
  averageIntensityFactor: number;
  estimatedRecoveryHours: number;
};

export type SparkPoint = { t: number; hr: number };

export enum FlagColor {
  Green = 0,
  GreenAmber = 1,
  Amber = 2,
  Red = 3,
  DarkRed = 4,
}

export type WeekReport = {
  weeklyLoad: number;
  meanLoad: number;
  stdDev: number;
  monotony: number;
  strain: number;
  monoFlag: FlagColor;
  strainFlag: FlagColor;
  decisionFlag: FlagColor;
};

export type ActivityDashboardItem = {
  activityGuid: string;
  pulseMonitorActivityId: number;
  train?: IngestTrainRow | null;
  trainDate?: string | null;
  lastModifiedUtc: string;
  hasCsv: boolean;
  participants: MemberParticipantSummary[];

  trainingLoad?: TrainingLoadResult | null;
  epocTotal?: number | null;
  zoneLabel?: string | null;
  sparkline?: SparkPoint[] | null;

  _trainDate?: Date | null;
  _lastModified?: Date | null;
};

export type HrmLoanStatus = {
  hasHrmLoanHistory: boolean;
  hasPulseMonitorProfile: boolean;
  currentHrmDeviceNumber?: string | null;
  currentHrmSku?: string | null;
  currentHrmProductName?: string | null;
};

export type ActivitiesDashboardResponse = {
  activities: ActivityDashboardItem[];
  dailyLoads: number[];
  weekReport: WeekReport;
  hrmLoanStatus?: HrmLoanStatus | null;
};

export type ActivitiesDashboardProps = {
  limit?: number;
  sparklineCount?: number;
};


